<template>

  <div class="col-lg p-0 mx-4" style="background: none;">
        <commentMilestone />
        <targetMilestone />
        <improvementMilestone />
        <!-- <loyaltyMilestone /> -->

        
      


  </div>
</template>

<script>
import commentMilestone from "@/components/engagement/profilePage/milestones/commentMilestone.vue";
import targetMilestone from "@/components/engagement/profilePage/milestones/targetMilestone.vue";
import improvementMilestone from "@/components/engagement/profilePage/milestones/improvementMilestone.vue";
import loyaltyMilestone from "@/components/engagement/profilePage/milestones/loyaltyMilestone.vue";

export default {
  mixins: [],
  props: ["user"],
  components: {
      commentMilestone,
      targetMilestone,
      improvementMilestone,
      loyaltyMilestone
  },

  mounted() {},
  methods: {
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";
</style>